<template>
	<quote-modal :tray-image-url="trayImageUrl" :tray-name="selectedTrayName" :tray-size="selectedTraySize" :product-code="productCode" v-if="showQuoteModal" @close="showQuoteModal = false"></quote-modal>
	<email-modal :tray-image-url="trayImageUrl" v-if="showEmailModal" @close="showEmailModal = false"></email-modal>
	<div class="personal rectangle">
		<div class="header">
			<a href="https://cambro.com/traydesigner/rectangular-trays" class="left-arrow" target="_parent">
				<img src="images/left.svg" />
			</a>
			<h1>Camtrays</h1>
		</div>
		<div class="personal-left" ref="trayContainer">
			<div class="tray-note">
				Rectangular Trays can be personalized in several ways.
				<ol>
					<li>Front of tray only.</li>
					<li>Back of tray only.</li>
					<li>Front and Back with the same design.</li>
					<li>Front and Back with a separate design on each side.</li>
				</ol>
			</div>
			<div id="tray-container-front">
				<transition name="fade" mode="out-in">
					<img :src="selectedTrayImage" :key="selectedTrayImage" width="100%" />
				</transition>
				<div v-if="uploadedImage" class="uploaded-image-front">
					<img :src="uploadedImage" alt="Uploaded Image" ref="targetElement" />
				</div>
				<moveable
					:target="targetElement"
					:draggable="true"
					:resizable="{ keepRatio: true }"
					:scalable="true"
					:rotatable="true"
					@drag="handleDragFront"
					@resize="handleResize"
					@scale="handleScale"
					@rotate="handleRotate"
				/>
				<div class="tray-front">Front</div>
			</div>
			<div id="tray-container-back">
				<transition name="fade" mode="out-in">
					<img :src="selectedTrayImageBack" :key="selectedTrayImageBack" width="100%" />
				</transition>
				<div v-if="uploadedImageBack" class="uploaded-image-back">
					<img :src="uploadedImageBack" alt="Uploaded Image" ref="targetElementBack" />
				</div>
				<moveable
					:target="targetElementBack"
					:draggable="true"
					:resizable="{ keepRatio: true }"
					:scalable="true"
					:rotatable="true"
					@drag="handleDragBack"
					@resize="handleResize"
					@scale="handleScale"
					@rotate="handleRotate"
				/>
				<div class="tray-back">Back</div>
			</div>
			<div class="coach">Click uploaded image to move it. Hold and drag corners to resize.</div>
		</div>
		<div class="personal-right">
			<h4>Select a Color</h4> <h5>{{ selectedTrayName }}</h5>
			<div class="select-color">
				<a href="javascript:void(0)" class="AmazonBlue123 active" @click="setActive($event, 'AmazonBlue123')"></a>
				<a href="javascript:void(0)" class="AntiqueParchment101" @click="setActive($event, 'AntiqueParchment101')"></a>
				<a href="javascript:void(0)" class="BayLeafBrown513" @click="setActive($event, 'BayLeafBrown513')"></a>
				<a href="javascript:void(0)" class="Black110" @click="setActive($event, 'Black110')"></a>
				<a href="javascript:void(0)" class="Blush409" @click="setActive($event, 'Blush409')"></a>
				<a href="javascript:void(0)" class="BrazilBrown116" @click="setActive($event, 'BrazilBrown116')"></a>
				<a href="javascript:void(0)" class="BurgundyWine522" @click="setActive($event, 'BurgundyWine522')"></a>
				<a href="javascript:void(0)" class="CambroRed521" @click="setActive($event, 'CambroRed521')"></a>
				<a href="javascript:void(0)" class="CameoYellow537" @click="setActive($event, 'CameoYellow537')"></a>
				<a href="javascript:void(0)" class="CherryRed505" @click="setActive($event, 'CherryRed505')"></a>
				<a href="javascript:void(0)" class="CitrusOrange220" @click="setActive($event, 'CitrusOrange220')"></a>
				<a href="javascript:void(0)" class="CottageWhite538" @click="setActive($event, 'CottageWhite538')"></a>
				<a href="javascript:void(0)" class="DarkPeach117" @click="setActive($event, 'DarkPeach117')"></a>
				<a href="javascript:void(0)" class="DesertTan104" @click="setActive($event, 'DesertTan104')"></a>
				<a href="javascript:void(0)" class="EarthenGold514" @click="setActive($event, 'EarthenGold514')"></a>
				<a href="javascript:void(0)" class="EverRed221" @click="setActive($event, 'EverRed221')"></a>
				<a href="javascript:void(0)" class="Grape551" @click="setActive($event, 'Grape551')"></a>
				<a href="javascript:void(0)" class="HorizonBlue105" @click="setActive($event, 'HorizonBlue105')"></a>
				<a href="javascript:void(0)" class="KeyLime429" @click="setActive($event, 'KeyLime429')"></a>
				<a href="javascript:void(0)" class="LemonChiffon536" @click="setActive($event, 'LemonChiffon536')"></a>
				<a href="javascript:void(0)" class="LightPeach106" @click="setActive($event, 'LightPeach106')"></a>
				<a href="javascript:void(0)" class="LimeAde113" @click="setActive($event, 'LimeAde113')"></a>
				<a href="javascript:void(0)" class="Mustard504" @click="setActive($event, 'Mustard504')"></a>
				<a href="javascript:void(0)" class="OliveGreen428" @click="setActive($event, 'OliveGreen428')"></a>
				<a href="javascript:void(0)" class="OrangePizzazz222" @click="setActive($event, 'OrangePizzazz222')"></a>
				<a href="javascript:void(0)" class="PearlGray107" @click="setActive($event, 'PearlGray107')"></a>
				<a href="javascript:void(0)" class="RaspberryCream410" @click="setActive($event, 'RaspberryCream410')"></a>
				<a href="javascript:void(0)" class="RealRust501" @click="setActive($event, 'RealRust501')"></a>
				<a href="javascript:void(0)" class="RobinEggBlue518" @click="setActive($event, 'RobinEggBlue518')"></a>
				<a href="javascript:void(0)" class="SherwoodGreen119" @click="setActive($event, 'SherwoodGreen119')"></a>
				<a href="javascript:void(0)" class="SignalRed510" @click="setActive($event, 'SignalRed510')"></a>
				<a href="javascript:void(0)" class="SkyBlue177" @click="setActive($event, 'SkyBlue177')"></a>
				<a href="javascript:void(0)" class="SlateBlue401" @click="setActive($event, 'SlateBlue401')"></a>
				<a href="javascript:void(0)" class="SuedeBrown508" @click="setActive($event, 'SuedeBrown508')"></a>
				<a href="javascript:void(0)" class="Taupe199" @click="setActive($event, 'Taupe199')"></a>
				<a href="javascript:void(0)" class="Teal414" @click="setActive($event, 'Teal414')"></a>
				<a href="javascript:void(0)" class="TuscanGold171" @click="setActive($event, 'TuscanGold171')"></a>
				<a href="javascript:void(0)" class="White148" @click="setActive($event, 'White148')"></a>
			</div>

			<h4>Add a Front Photo</h4>
			<input type="file" @change="onFileChange" ref="fileInput" />
            <button @click="resetUploadFront" class="btn-reset">Remove Image</button>
            <h4>Add a Back Photo</h4>
			<input type="file" @change="onFileChangeBack" ref="fileInputBack" />
  			<button @click="resetUploadBack" class="btn-reset">Remove Image</button>
			<div class="cleaner"></div>

			<h4>Select a Size</h4>
			<div class="select-size">
				<select name="size" id="select-dropdown" v-model="selectedSizeCode" @change="selectSize">
					<option value="46">4" x 6" (11 x 15 cm)</option>
					<option value="57">5"  x 7" (12,5 x 18 cm)</option>
					<option value="810">8" x 10" (20,5 x 25 cm)</option>
					<option value="915">9" x 15" (22 x 38 cm)</option>
					<option value="926">9" x 26" (22,5 x 65 cm)</option>
					<option value="1014">10" x 14" (27 x 35 cm)</option>
					<option value="1015">10" x 15" (26 x 38 cm)</option>
					<option value="1116">11" x 16" (27,5 x 40,5 cm)</option>
					<option value="1216">12" x 16" (30,5  x 41,5 cm)</option>
					<option value="1313">13" x 13" (33 x 33 cm)</option>
					<option value="1318">13" x 18" (32 x 45 cm)</option>
					<option value="1418">14" x 18" (35,5 x 45,7 cm)</option>
					<option value="1520">15" x 20" (38 x 51,5 cm)</option>
					<option value="1622">16" x 22" (40,5 x 56 cm)</option>
					<option value="1826">18" x 26" (45,5 x 65,5 cm)</option>
					<option value="2025">20" x 25" (53 x 65 cm)</option>
				</select>
			</div>
			<div>
				<h4>Your Tray Details</h4>
				<h5>Color: <strong>{{ selectedTrayName }}</strong></h5>
				<h5>Tray Size: <strong>{{ selectedTraySize }}</strong></h5>
				<h5>Product Code: <strong>{{ productCode }}</strong></h5>
			</div>
			<button @click="captureScreenshot(false)" class="btn-quote">Request a Free Sample and Quote</button>
			<button @click="downloadImage" class="btn-download">Download</button>
			<button @click="captureScreenshot(true)" class="btn-email">Email My Tray</button>

		</div>
	</div>
</template>
  
<script>
  import * as htmlToImage from 'html-to-image';
  import { toPng, toJpeg, toBlob, toPixelData, toSvg } from 'html-to-image';
  import QuoteModal from './Quote.vue';
  import EmailModal from './EmailForm.vue';
  import { ref, onMounted, onUnmounted } from 'vue';
  import Moveable from "vue3-moveable";
  import '../assets/rectangle.css';
  export default {
	components: {
		QuoteModal,
		EmailModal,
		Moveable
	},
	setup() {
		const targetElement = ref(null);
		const isMoveableActive = ref(false);
		const targetElementBack = ref(null);
		const handleClickOutside = (event) => {
			if (targetElement.value && !targetElement.value.contains(event.target)) {
				isMoveableActive.value = false;
			}
		};
		onMounted(() => {
			document.addEventListener('click', handleClickOutside);
		});
		onUnmounted(() => {
			document.removeEventListener('click', handleClickOutside);
		});
		const handleDragFront = ({ beforeTranslate }) => {
		targetElement.value.style.transform =
			`translate(${beforeTranslate[0]}px, ${beforeTranslate[1]}px)`;
		};
        const handleDragBack = ({ beforeTranslate }) => {
		targetElementBack.value.style.transform =
			`translate(${beforeTranslate[0]}px, ${beforeTranslate[1]}px)`;
		};
		const handleResize = ({ target, width, height, delta }) => {
			const aspectRatio = target.offsetWidth / target.offsetHeight;
			let newWidth = width;
			let newHeight = height;
			target.style.width = `${newWidth}px`;
    		target.style.height = `${newHeight}px`;
		};
		const handleScale = ({ target, dist }) => {
			const scaleX = dist[0];
			const scaleY = dist[1];
			target.style.transform = `scale(${scaleX}, ${scaleY})`;
		};
		const handleRotateFront = ({ beforeRotate }) => {
		targetElement.value.style.transform = `rotate(${beforeRotate}deg)`;
		};
        const handleRotateBack = ({ beforeRotate }) => {
		targetElementBack.value.style.transform = `rotate(${beforeRotate}deg)`;
		};

    return {
		targetElement,
        targetElementBack,
		handleDragFront,
        handleDragBack,
		handleResize,
		handleScale,
		handleRotateFront,
        handleRotateBack,
		isMoveableActive,
    };
  },
	data() {
	  return {
		showQuoteModal: false,
      	showEmailModal: false,
			emailFormData: {
			recipientEmail: '',
			message: '',
		},
		selectedTrayImage: 'images/rectangle/camtrays/Amazon-Blue-123.png',
		selectedTrayImageBack: 'images/rectangle/camtrays/back/Amazon-Blue-123.png',
		selectedColor: 'AmazonBlue123',
		selectedTrayName: 'Amazon Blue',
		selectedTrayCode: '46123',
    	selectedTraySize: '4" x 6" (11 x 15 cm)',
		selectedSizeCode: '46',
		uploadedImage: null,
		uploadedImageBack: null,
		screenshot: null,
		colorToImageMap: {
			AmazonBlue123: {
				front: 'images/rectangle/camtrays/Amazon-Blue-123.png',
				back: 'images/rectangle/camtrays/back/Amazon-Blue-123.png'
			},
			AntiqueParchment101: {
				front: 'images/rectangle/camtrays/Antique-Parchment-101.png',
				back: 'images/rectangle/camtrays/back/Antique-Parchment-101.png'
			},
			BayLeafBrown513: {
				front: 'images/rectangle/camtrays/Bay-Leaf-Brown-513.png',
				back: 'images/rectangle/camtrays/back/Bay-Leaf-Brown-513.png'
			},
			Black110: {
				front: 'images/rectangle/camtrays/Black-110.png',
				back: 'images/rectangle/camtrays/back/Black-110.png'
			},
			Blush409: {
				front: 'images/rectangle/camtrays/Blush-409.png',
				back: 'images/rectangle/camtrays/back/Blush-409.png'
			},
			BrazilBrown116: {
				front: 'images/rectangle/camtrays/Brazil-Brown-116.png',
				back: 'images/rectangle/camtrays/back/Brazil-Brown-116.png'
			},
			BurgundyWine522: {
				front: 'images/rectangle/camtrays/Burgundy-Wine-522.png',
				back: 'images/rectangle/camtrays/back/Burgundy-Wine-522.png'
			},
			CambroRed521: {
				front: 'images/rectangle/camtrays/Cambro-Red-521.png',
				back: 'images/rectangle/camtrays/back/Cambro-Red-521.png'
			},
			CameoYellow537: {
				front: 'images/rectangle/camtrays/Cameo-Yellow-537.png',
				back: 'images/rectangle/camtrays/back/Cameo-Yellow-537.png'
			},
			CherryRed505: {
				front: 'images/rectangle/camtrays/Cherry-Red-505.png',
				back: 'images/rectangle/camtrays/back/Cherry-Red-505.png'
			},
			CitrusOrange220: {
				front: 'images/rectangle/camtrays/Citrus-Orange-220.png',
				back: 'images/rectangle/camtrays/back/Citrus-Orange-220.png'
			},
			CottageWhite538: {
				front: 'images/rectangle/camtrays/Cottage-White-538.png',
				back: 'images/rectangle/camtrays/back/Cottage-White-538.png'
			},
			DarkPeach117: {
				front: 'images/rectangle/camtrays/Dark-Peach-117.png',
				back: 'images/rectangle/camtrays/back/Dark-Peach-117.png'
			},
			DesertTan104: {
				front: 'images/rectangle/camtrays/Desert-Tan-104.png',
				back: 'images/rectangle/camtrays/back/Desert-Tan-104.png'
			},
			EarthenGold514: {
				front: 'images/rectangle/camtrays/Earthen-Gold-514.png',
				back: 'images/rectangle/camtrays/back/Earthen-Gold-514.png'
			},
			EverRed221: {
				front: 'images/rectangle/camtrays/Ever-Red-221.png',
				back: 'images/rectangle/camtrays/back/Ever-Red-221.png'
			},
			Grape551: {
				front: 'images/rectangle/camtrays/Grape-551.png',
				back: 'images/rectangle/camtrays/back/Grape-551.png'
			},
			HorizonBlue105: {
				front: 'images/rectangle/camtrays/Horizon-Blue-105.png',
				back: 'images/rectangle/camtrays/back/Horizon-Blue-105.png'
			},
			KeyLime429: {
				front: 'images/rectangle/camtrays/Key-Lime-429.png',
				back: 'images/rectangle/camtrays/back/Key-Lime-429.png'
			},
			LemonChiffon536: {
				front: 'images/rectangle/camtrays/Lemon-Chiffon-536.png',
				back:  'images/rectangle/camtrays/back/Lemon-Chiffon-536.png'
			},
			LightPeach106: {
				front: 'images/rectangle/camtrays/Light-Peach-106.png',
				back: 'images/rectangle/camtrays/back/Light-Peach-106.png'
			},
			LimeAde113: {
				front: 'images/rectangle/camtrays/Lime-Ade-113.png',
				back: 'images/rectangle/camtrays/back/Lime-Ade-113.png'
			},
			Mustard504: {
				front: 'images/rectangle/camtrays/Mustard-504.png',
				back: 'images/rectangle/camtrays/back/Mustard-504.png'
			},
			OliveGreen428: {
				front: 'images/rectangle/camtrays/Olive-Green-428.png',
				back: 'images/rectangle/camtrays/back/Olive-Green-428.png'
			},
			OrangePizzazz222: {
				front: 'images/rectangle/camtrays/Orange-Pizzazz-222.png',
				back: 'images/rectangle/camtrays/back/Orange-Pizzazz-222.png'
			},
			PearlGray107: {
				front: 'images/rectangle/camtrays/Pearl-Gray-107.png',
				back: 'images/rectangle/camtrays/back/Pearl-Gray-107.png'
			},
			RaspberryCream410: {
				front: 'images/rectangle/camtrays/Raspberry-Cream-410.png',
				back: 'images/rectangle/camtrays/back/Raspberry-Cream-410.png'
			},
			RealRust501: {
				front: 'images/rectangle/camtrays/Real-Rust-501.png',
				back: 'images/rectangle/camtrays/back/Real-Rust-501.png'
			},
			RobinEggBlue518: {
				front: 'images/rectangle/camtrays/Robin-Egg-Blue-518.png',
				back: 'images/rectangle/camtrays/back/Robin-Egg-Blue-518.png'
			},
			SherwoodGreen119: {
				front: 'images/rectangle/camtrays/Sherwood-Green-119.png',
				back: 'images/rectangle/camtrays/back/Sherwood-Green-119.png'
			},
			SignalRed510: {
				front: 'images/rectangle/camtrays/Signal-Red-510.png',
				back: 'images/rectangle/camtrays/back/Signal-Red-510.png'
			},
			SkyBlue177: {
				front: 'images/rectangle/camtrays/Sky-Blue-177.png',
				back: 'images/rectangle/camtrays/back/Sky-Blue-177.png'
			},
			SlateBlue401: {
				front: 'images/rectangle/camtrays/Slate-Blue-401.png',
				back: 'images/rectangle/camtrays/back/Slate-Blue-401.png'
			},
			SuedeBrown508: {
				front: 'images/rectangle/camtrays/Suede-Brown-508.png',
				back: 'images/rectangle/camtrays/back/Suede-Brown-508.png'
			},
			Taupe199: {
				front: 'images/rectangle/camtrays/Taupe-199.png',
				back: 'images/rectangle/camtrays/back/Taupe-199.png'
			},
			Teal414: {
				front: 'images/rectangle/camtrays/Teal-414.png',
				back: 'images/rectangle/camtrays/back/Teal-414.png'
			},
			TuscanGold171: {
				front: 'images/rectangle/camtrays/Tuscan-Gold-171.png',
				back: 'images/rectangle/camtrays/back/Tuscan-Gold-171.png'
			},
			White148: {
				front: 'images/rectangle/camtrays/White-148.png',
				back: 'images/rectangle/camtrays/back/White-148.png'
			},
		}
	  };
	},
	methods: {
		print(val) {
			console.log(val)
		},
		captureScreenshot() {
			const node = this.$refs.trayContainer;
			htmlToImage.toPng(node, {
			filter: function (node) {
				return node.nodeType === Node.ELEMENT_NODE && !node.classList.contains('rCS1w3zcxh') && !node.classList.contains('coach') && !node.classList.contains('tray-note');
				}
			})
				.then((dataUrl) => {
				this.trayImageUrl = dataUrl;
				this.showModal = true;
				})
				.catch((error) => {
				console.error('Failed to capture screenshot', error);
			});
			this.showEmailModal = true;
		},
		captureScreenshot(openEmailModal = false) {
		const node = this.$refs.trayContainer;
		htmlToImage.toPng(node, {
			filter: function (node) {
				return node.nodeType === Node.ELEMENT_NODE && !node.classList.contains('rCS1w3zcxh') && !node.classList.contains('coach') && !node.classList.contains('tray-note');
				}
			})
			.then((dataUrl) => {
				this.trayImageUrl = dataUrl;
				if (openEmailModal) {
					this.showEmailModal = true;
					this.showQuoteModal = false;
				} else {
					this.showQuoteModal = true;
					this.showEmailModal = false;
				}
			})
			.catch((error) => {
				console.error('Failed to capture screenshot', error);
			});
		},
		resetUploadFront() {
			this.uploadedImage = null;
			this.$refs.fileInput.value = '';
		},
		resetUploadBack() {
			this.uploadedImageBack = null;
			this.$refs.fileInput.value = '';
		},
		setActive(event, color) {
			this.selectedColor = color;
			this.selectedTrayImage = this.colorToImageMap[color].front;
			this.selectedTrayImageBack = this.colorToImageMap[color].back;
			this.selectedTrayName = this.formatTrayName(color);
			const swatches = document.querySelectorAll('.select-color a');
			swatches.forEach(sw => sw.classList.remove('active'));
			event.currentTarget.classList.add('active');
		},
    selectColor(color) {
      this.selectedTrayImage = this.colorToImageMap[color];
      this.selectedTrayName = this.formatTrayName(colorCode);
    },
    onFileChange(e) {
      const files = e.target.files;
      if (files.length > 0) {
        const fileReader = new FileReader();
        fileReader.readAsDataURL(files[0]);
        fileReader.onload = (e) => {
          this.uploadedImage = e.target.result;
        };
      }
    },
    onFileChangeBack(e) {
      const files = e.target.files;
      if (files.length > 0) {
        const fileReader = new FileReader();
        fileReader.readAsDataURL(files[0]);
        fileReader.onload = (e) => {
          this.uploadedImageBack = e.target.result;
        };
      }
    },
	formatTrayName(className) {
		return className
		.replace(/\d+/g, '') // Remove numbers
		.replace(/([a-z])([A-Z])/g, '$1 $2') // Add space before capital letters
		.trim() // Remove leading and trailing spaces
		.split(' ')
		.map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) // Capitalize first letter of each word
		.join(' ');
	},
	selectSize(event) {
		this.selectedSizeCode = event.target.value;
		let selectedOption = event.target.options[event.target.selectedIndex];
		this.selectedTraySize = selectedOption ? selectedOption.text : '';
	},
	downloadImage() {
			const node = this.$refs.trayContainer;
			htmlToImage.toPng(node, {
			filter: function (node) {
				return node.nodeType === Node.ELEMENT_NODE && !node.classList.contains('rCS1w3zcxh') && !node.classList.contains('coach') && !node.classList.contains('tray-note');
				}
			})
			.then((dataUrl) => {
				const link = document.createElement('a');
				link.href = dataUrl;
				link.download = 'My-Custom-Cambro-Tray.png';
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
			})
			.catch((error) => {
				console.error('Failed to download image', error);
			});
		},
  emailImage() {
      const trayElement = document.getElementById('tray-container');
      html2canvas(trayElement).then((canvas) => {
        canvas.toBlob((blob) => {
          // Convert blob to a data URL
          const reader = new FileReader();
          reader.readAsDataURL(blob);
          reader.onloadend = () => {
            const base64data = reader.result;
            const subject = encodeURIComponent('Check out my custom Cambro tray');
            const body = encodeURIComponent(
              `Check out the custom tray I designed: ${base64data}\n\n` +
              `You can design your own here: https://appscambro.com/tray-personalization`
            );
            // Open the default mail client (you cannot attach the image file due to security reasons, but you can include it as a data URL)
            window.open(`mailto:?subject=${subject}&body=${body}`);
          };
        });
      });
  },
  },
  computed: {
	selectedTrayName() {
    const colorName = this.formatTrayName(this.selectedColor);
    const colorCodeMatch = this.selectedColor.match(/(\d+)$/);
    const colorCode = colorCodeMatch ? colorCodeMatch[1] : '';
    return `${colorName} (${colorCode})`;
  },
	productCode() {
		let sizeCode = this.selectedSizeCode ? this.selectedSizeCode.match(/\d+/) : [''];
		let colorCode = this.selectedColor ? this.selectedColor.match(/\d+/) : [''];
		return `${sizeCode[0]}${colorCode[0]}`;
	}
  },
};
</script>
  
